<app-loader *ngIf="isDisabled"></app-loader>
<form class="g-3" name="PreOnBoardingSetupForm" (ngSubmit)="Validate(PreOnBoardingSetupForm)"
    #PreOnBoardingSetupForm="ngForm" novalidate>
    <div class="card">
        <div class="card-body p-0">
            <div class="card mb-2">
                <div class="card-header">
                    Pre On Boarding Detail
                </div>
                <div class="card-body">
                    <div class="row">
                        <div class="col-md-6">
                            <label class="small-light-label">Full Name</label><br />
                            <label style="font-weight:600">{{PreonboardinSetupDetail.EmployeeName}}</label><br />
                            <label style="font-weight:600">#{{PreonboardinSetupDetail.EmpCode}}</label>
                        </div>
                        <div class="col-md-6">
                            <label class="small-light-label">EmpType</label><br />
                            <label>{{PreonboardinSetupDetail.EmpType}}</label>
                        </div>
                        <!-- <div class="col-md-6">
                            <label class="small-light-label">MobileNo</label><br />
                            <label>{{PreonboardinSetupDetail.MobileNo}}</label>
                        </div>
                        <div class="col-md-6">
                            <label class="small-light-label">EmailID</label><br />
                            <label>{{PreonboardinSetupDetail.Email}}</label>
                        </div> -->
                    </div>
                </div>
            </div>
            <div class="card-body p-0">
                <div class="card mb-2">
                    <div class="card-header">
                        Pre On Boarding Initiation
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-md-4">
                                <label for="URLValidity" class="form-font-label"><span
                                        class="mandatory-field">*</span>URL Validity Days</label>
                                <input type="text" class="form-control" placeholder="Ex. 5" id="URLValidity"
                                    name="URLValidity" [(ngModel)]="PreonboardinSetupDetail.URLValidity" maxlength="2"
                                    (keypress)="common.NumberOnly($event)" pattern="^[0-9]\d*$" #URLValidity="ngModel"
                                    required>
                                <div class="invalid-feedback">
                                    Please enter URL validity!
                                </div>
                            </div>
                            <div class="col-md-4"
                                *ngIf="common.ToLowerCase(PreonboardinSetupDetail.EmpType) == 'front'">
                                <label for="EmployeeServiceTypeID" class="form-font-label">Employee Service Type</label>
                                <ng-select name="EmployeeServiceTypeID" placeholder="Select Employee Service Type"
                                    [selectOnTab]="true" [(ngModel)]="PreonboardinSetupDetail.EmpServiceTypeId"
                                    #EmployeeServiceTypeID="ngModel">
                                    <ng-option *ngFor="let EmpServiceType of EmpServiceTypes"
                                        [value]="EmpServiceType.ServiceTypeID">{{EmpServiceType.ServiceTypeName}}</ng-option>
                                </ng-select>
                                <div class="invalid-feedback">
                                    Please select employee service type
                                </div>
                            </div>
                            <div class="col-md-4">
                                <label for="JoiningDate" class="form-font-label">Joining Date<span
                                        class="mandatory-field">*</span></label>
                                <div class="input-group">
                                    <input class="form-control" placeholder="DD MMM YYYY" name="JoiningDate"
                                        [(ngModel)]="PreonboardinSetupDetail.JoiningDate" ngbDatepicker
                                        #JoiningDate="ngbDatepicker" (ngModelChange)="JoiningDateChange($event)"
                                        [minDate]="PreJoiningDate" [maxDate]="PostJoiningDate" required />
                                    <button class="btn btn-outline-secondary bi bi-calendar3"
                                        (click)="JoiningDate.toggle()" type="button"></button>
                                </div>
                                <div class="invalid-feedback">
                                    enter spouse joining date!
                                </div>
                            </div>
                            <!-- <div class="col-md-3">
                                <label for="ProbationDate" class="form-font-label">Probation Date<span
                                        class="mandatory-field">*</span></label>
                                <div class="input-group">
                                    <input class="form-control" placeholder="DD MMM YYYY" name="ProbationDate"
                                        [(ngModel)]="PreonboardinSetupDetail.ProbationDate" ngbDatepicker
                                        #ProbationDate="ngbDatepicker" required />
                                    <button class="btn btn-outline-secondary bi bi-calendar3"
                                        (click)="ProbationDate.toggle()" type="button"></button>
                                </div>
                                <div class="invalid-feedback">
                                    enter probation date!
                                </div>
                            </div> -->
                        </div>
                        <div class="row">
                            <div class="col-md-4">
                                <label for="BranchID" class="form-font-label">Branch<span
                                        class="mandatory-field">*</span></label>
                                <ng-select name="BranchID" placeholder="Select branch" [selectOnTab]="true"
                                    [(ngModel)]="PreonboardinSetupDetail.BranchID"
                                    (change)="common.ToLowerCase(PreonboardinSetupDetail.EmpType) == 'front'?ComboLoad('Client'):null;ComboLoad('Approval1')"
                                    required>
                                    <ng-option *ngFor="let Branch of Branchs"
                                        [value]="Branch.BranchMasterID">{{Branch.BranchName}}</ng-option>
                                </ng-select>
                            </div>
                            <div class="col-md-4"
                                *ngIf="common.ToLowerCase(PreonboardinSetupDetail.EmpType) == 'front'">
                                <label for="ClientId" class="form-font-label">Client<span
                                        class="mandatory-field">*</span></label>
                                <ng-select name="ClientId" placeholder="Select Client" [selectOnTab]="true"
                                    [(ngModel)]="PreonboardinSetupDetail.ClientId" (change)="ComboLoad('Site')"
                                    required>
                                    <ng-option *ngFor="let Client of Clients"
                                        [value]="Client.ClientGroupMasterID">{{Client.ClientGroupName}}</ng-option>
                                </ng-select>
                                <div class="invalid-feedback">
                                    Please select client
                                </div>
                            </div>
                            <div class="col-md-4"
                                *ngIf="common.ToLowerCase(PreonboardinSetupDetail.EmpType) == 'front'">
                                <label for="SiteId" class="form-font-label">Site<span
                                        class="mandatory-field">*</span></label>
                                <ng-select name="SiteId" placeholder="Select Site" [selectOnTab]="true"
                                    [(ngModel)]="PreonboardinSetupDetail.SiteId" (change)="ComboLoad('Designation')"
                                    required>
                                    <ng-option *ngFor="let Site of Sites"
                                        [value]="Site.SiteMasterID">{{Site.SiteName}}</ng-option>
                                </ng-select>
                                <div class="invalid-feedback">
                                    Please select site
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-4">
                                <label for="DesignationId" class="form-font-label">Designation<span
                                        class="mandatory-field">*</span></label>
                                <ng-select name="DesignationId" placeholder="Select Designation" [selectOnTab]="true"
                                    [(ngModel)]="PreonboardinSetupDetail.DesignationId" (change)="ComboLoad('Duty')"
                                    required>
                                    <ng-option *ngFor="let Designation of Designations"
                                        [value]="Designation.DesignationMasterID">{{Designation.DesignationName}}</ng-option>
                                </ng-select>
                                <div class="invalid-feedback">
                                    Please select designation
                                </div>
                            </div>
                            <div class="col-md-4" *ngIf="common.ToLowerCase(PreonboardinSetupDetail.EmpType) == 'front'">
                                <label for="DutyId" class="form-font-label">Duty</label>
                                <ng-select name="DutyId" placeholder="Select Duty" [selectOnTab]="true"
                                    [(ngModel)]="PreonboardinSetupDetail.DutyId">
                                    <ng-option *ngFor="let Duty of Dutys"
                                        [value]="Duty.DutyMasterID">{{Duty.DutyName}}</ng-option>
                                </ng-select>
                                <div class="invalid-feedback">
                                    Please select duty
                                </div>
                            </div>
                            <div class="col-md-4">
                                <label for="ShiftId" class="text-label-dark">Shift </label>
                                <ng-select name="ShiftId" placeholder="Select Shift"
                                    [(ngModel)]="PreonboardinSetupDetail.ShiftId" [selectOnTab]="true">
                                    <ng-option *ngFor="let Shift of Shifts"
                                        [value]="Shift.ShiftMasterID">{{Shift.ShiftTitle}}</ng-option>
                                </ng-select>
                                <div class="invalid-feedback">
                                    Please select shift!
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-3">
                                <label for="Email" class="text-label-dark">Email <span
                                        class="mandatory-field">*</span></label>
                                <input type="Email" class="form-control" placeholder="Ex. xyz@domain.com" id="Email"
                                    name="Email" [(ngModel)]="PreonboardinSetupDetail.Email" #Email="ngModel"
                                    oninput="var startPos = this.selectionStart;var endPos = this.selectionEnd;this.value = this.value.toUpperCase();this.setSelectionRange(startPos, endPos);"
                                    pattern="[A-Za-z0-9._+\-']+@[A-Za-z0-9.\-]+\.[A-Za-z]{2,}$" required>
                                <div class="invalid-feedback">
                                    Please enter a valid personal email id! eg. 'example&#64;abc.com'
                                </div>
                            </div>
                            <div class="col-md-3">
                                <label for="MobileNo" class="text-label-dark">Contact No <span
                                        class="mandatory-field">*</span></label>
                                <input type="text" maxlength="10" pattern="^(?:[1-9]\d*|0)$" class="form-control"
                                    placeholder="Ex. 9876543210" (keypress)="common.NumberOnly($event)" id="MobileNo"
                                    name="MobileNo" [(ngModel)]="PreonboardinSetupDetail.MobileNo" #MobileNo="ngModel"
                                    required>
                                <div class="invalid-feedback">
                                    Please enter 10 digit contact no!
                                </div>
                            </div>
                            <div class="col-md-3">
                                <label for="Approval1" class="form-font-label">Reporting Manager 1<span *ngIf="!IsReportingToNotApplicable"
                                        class="mandatory-field">*</span></label>
                                <ng-select name="Approval1" placeholder="Select Reporting Manager" [selectOnTab]="true"
                                    [(ngModel)]="PreonboardinSetupDetail.FirstApproverId" [required]="!IsReportingToNotApplicable">
                                    <ng-option *ngFor="let Approval of Approvals1"
                                        [value]="Approval.UserMasterId">{{Approval.Name}}</ng-option>
                                </ng-select>
                                <div class="invalid-feedback">
                                    Please select reporting manager 1
                                </div>
                            </div>
                            <div class="col-md-3">
                                <label for="Approval2" class="form-font-label">Reporting Manager 2</label>
                                <ng-select name="Approval2" placeholder="Select Reporting Manager" [selectOnTab]="true"
                                    [(ngModel)]="PreonboardinSetupDetail.SecondApproverId">
                                    <ng-option *ngFor="let Approval of Approvals2"
                                        [value]="Approval.UserMasterId">{{Approval.Name}}</ng-option>
                                </ng-select>
                                <div class="invalid-feedback">
                                    Please select reporting manager 2
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="card-footer">
            <div class="d-grid gap-2 d-md-flex justify-content-md-end">
                <button type="button" class="btn btn-outline-secondary btn-sm" [disabled]="isDisabled"
                    (click)="close()"><i class="bi bi-x" *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Cancel':'Loading...'}}</button>

                <div *ngIf="this.common.PageRight.IsEdit" class="d-grid gap-2 d-md-flex justify-content-md-end">
                    <button type="submit" class="btn btn-primary" [disabled]="isDisabled"><i class="bi bi-chevron-right"
                            *ngIf="!isDisabled"></i>
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                            *ngIf="isDisabled"></span>
                        {{!isDisabled?'On Board':'Loading...'}}</button>
                </div>
            </div>
        </div>
    </div>
</form>